export enum HighwayMaintenanceFeeTicketState {
  PENDING = 'PENDING', // 待處理、待查詢
  // 已查詢，有問題的狀態
  NO_FEE = 'NO_FEE', // 無需繳費
  QUERY_FAILED = 'QUERY_FAILED', // 查詢失敗
  // 已查詢，需繳費的狀態
  CHARGING = 'CHARGING', // 扣款中
  CHARGE_FAILED = 'CHARGE_FAILED', // 請款失敗
  CHARGE_SUCCESS = 'CHARGE_SUCCESS', // 請款成功
  COMPLETED = 'COMPLETED', // 繳費完成
}

export const HIGHWAY_MAINTENANCE_FEE_STATE_VALUE = Object.values(
  HighwayMaintenanceFeeTicketState,
);

export const HIGHWAY_MAINTENANCE_FEE_TICKET_STATE_POLICY = {
  [HighwayMaintenanceFeeTicketState.PENDING]: {
    text: '待處理',
  },
  [HighwayMaintenanceFeeTicketState.NO_FEE]: {
    text: '無需繳費',
  },
  [HighwayMaintenanceFeeTicketState.QUERY_FAILED]: {
    text: '查詢失敗',
  },
  [HighwayMaintenanceFeeTicketState.CHARGING]: {
    text: '扣款中',
  },
  // only come from server operation
  [HighwayMaintenanceFeeTicketState.CHARGE_SUCCESS]: {
    text: '請款成功',
  },
  // only come from server operation
  [HighwayMaintenanceFeeTicketState.CHARGE_FAILED]: {
    text: '請款失敗',
  },
  [HighwayMaintenanceFeeTicketState.COMPLETED]: {
    text: '繳費完成',
  },
} as const satisfies Record<
  HighwayMaintenanceFeeTicketState,
  {
    text: string;
  }
>;
